const EndPoints = {
  META: '/api/meta',
  VISITORS: (id: string) => `/api/visa_requests/${id}/visitors`,
  VISA_REQUEST: (id: string) => `/api/visa_requests/${id}`,
  APPLICATION_TOKEN: (token: string) =>
    `/api/visa_applications/remote_application/?visa_application_token=${token}`,
  NEW_VISA_REQUEST: '/visa_requests',
};

export default EndPoints;
